import React from "react";
import { CheckboxCore, CheckboxProps } from "./CheckboxCore";
import CheckboxGroup, { CheckboxGroupProps } from "./CheckboxGroup";

/**
 * Checkbox group info.
 *
 * @param {CheckboxGroupProps} props - The properties of the component.
 * @property {Option[]} options - The list of options to display in the checkbox group.
 * @property {string[]} [value] - The currently selected values.
 * @property {function} [onChange] - Function called when the checkbox selection changes.
 * @returns {React.ReactElement} The checkbox group component.
 *
 *
 * @example
 * <Checkbox.Group
 *   options={[
 *     { label: 'Option 1', value: '1' },
 *     { label: 'Option 2', value: '2', disabled: true },
 *     { label: 'Option 3', value: '3' }
 *   ]}
 *   onChange={(selectedValues) => console.log(selectedValues)}
 * />
 */

export const Checkbox: React.FC<CheckboxProps> & { Group: React.FC<CheckboxGroupProps> } = (
   props,
) => {
   return <CheckboxCore {...props} />;
};

Checkbox.Group = CheckboxGroup;

export default Checkbox;
export type { CheckboxProps };
